<div>
  <label>{{label}}</label>
  @if (inputModel) {
    <span>{{inputModel}}</span>
  }
  @if (!inputModel) {
    <span>None</span>
  }
  <hr/>
</div>